import ControlList from '../../utilities/Control/ControlList'
import FormEvents from '../../utilities/FormEvents'
import { Keys } from './constants'
import { FormSubcategory, SubcategoryData } from './types'

export const controlList = new ControlList<SubcategoryData>(Keys.MAIN, {
    path: '/v5.6/apis/subcategories',
    theads: [
        '#',
        { value: 'code', label: 'Código' },
        { value: 'name', label: 'Subcategoría' },
        { value: 'category_name', label: 'Categorías' },
        'Acciones'
    ]
})

export const formSubcategory = new FormEvents<FormSubcategory>('FORM', {
    name: '',
    category_id: null
})
